module.exports = __webpack_public_path__ + "img/auto-in-null.svg";